import React, { useEffect, useState } from 'react';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Button,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';
import {
    Edit as EditIcon,
    Visibility as VisibilityIcon,
    Close as CloseIcon,
} from '@mui/icons-material';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import {
    DataGridPro,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid-pro';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import axios from '../../../axios-order';
import BusinessIcon from '@mui/icons-material/Business';
import { Container, Grid } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import SelectInput from '../../../components/ui/basicSelectInput';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';
import InputAdornment from '@mui/material/InputAdornment';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { LoadingButton } from '@mui/lab';
import DownloadIcon from '@mui/icons-material/Download';

const MasterTable = () => {
    const [supplierData, setSupplierData] = useState([]);
    const [formData, setFormData] = useState({
        gstin: '',
        recipient_gstin: '',
        recipient_pan: '',
        tradeName: '',
        address_two: '',
        phone: '',
        legalName: '',
        address_one: '',
        location: '',
        pinCode: '',
        emailId: '',
        state: '',
        mastertype: 'CUSTOMER',
        gstinReg: 'Regular',
    });
    const [masterList] = useState([
        { value: 'CUSTOMER', label: 'CUSTOMER' },
        { value: 'VENDOR', label: 'VENDOR' },
    ]);
    const [gstinRegList, setGstinRegList] = useState([]);
    const [addressForm, setAddressForm] = useState({
        gstin: '',
        pinCode: '',
        location: '',
        address1: '',
        address2: '',
        state: '',
    });
    const [addressDialogOpen, setAddressDialogOpen] = useState(false);
    const [bankDialogOpen, setBankDialogOpen] = useState(false);
    const [supplierFormDialogOpen, setSupplierFormDialogOpen] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState({});
    const [supplierDailogKey, setSupplierDailogKey] = useState('add');
    const [gstArray, setGstArray] = useState([]);
    const [legalNameArray, setLegalNameArray] = useState([]);
    const [stateArray, setStateArray] = useState([]);
    const [pincodeError, setPincodeError] = useState('');
    const [pincodeLoading, setPincodeLoading] = useState(false);
    const [pincodeValid, setPincodeValid] = useState(false);
    const [logoFile, setLogoFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [error, setError] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState('');
    const [message, setMessage] = useState('');
    const [responseMessage, setResponseMessage] = useState('');
    const [submitButtonLoading, setSubmitButtonLoading] = useState(false);
    const [form16DataLoading, setForm16DataLoading] = useState(false);
    const [supplierAddresses, setSupplierAddresses] = useState([]);
    const [selectedSubAddress, setSelectedSubAddress] = useState({});
    const [selectedBank, setSelectedBank] = useState({});
    const [bankDetails, setBankDetails] = useState([]);
    const [panDocument, setPanDocument] = useState(null);
    const [gstDocument, setGstDocument] = useState(null);
    const [otherDocument, setOtherDocument] = useState(null);
    const [previewPanUrl, setPanPreview] = useState(null);
    const [previewGstUrl, setGstPreview] = useState(null);
    const [previewOtherUrl, setOtherPreview] = useState(null);
    const [gstinError, setGstinError] = useState('');
    const [panFileName, setPanFileName] = useState('');
    const [gstFileName, setGstFileName] = useState('');
    const [otherFileName, setOtherFileName] = useState('');
    const [panError, setPanError] = useState('');

    const handleSnackbarOpen = (message, severity) => {
        setSnackbarSeverity(severity);
        setResponseMessage(message);
        setSnackbarOpen(true);
    };

    const handleDocumentUpload = (event, type) => {
        const file = event.target.files[0];
        if (!file) return;

        const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
        const maxSize = 5 * 1024 * 1024;

        if (!validTypes.includes(file.type)) {
            setError(`Invalid file type. Please upload PDF, JPG, or PNG.`);
            return;
        }

        if (file.size > maxSize) {
            setError(`File too large. Maximum size is 5MB.`);
            return;
        }

        const preview = URL.createObjectURL(file);

        const reader = new FileReader();
        reader.onloadend = () => {
            const base64Document = reader.result;
            switch (type) {
                case 'pan':
                    setPanDocument(base64Document);
                    setPanPreview(preview);
                    setPanFileName(file.name);
                    break;
                case 'gst':
                    setGstDocument(base64Document);
                    setGstPreview(preview);
                    setGstFileName(file.name);
                    break;
                case 'other':
                    setOtherDocument(base64Document);
                    setOtherPreview(preview);
                    setOtherFileName(file.name);
                    break;
                default:
                    break;
            }
        };
        reader.readAsDataURL(file);

        setError('');
    };

    const handleRemoveDocument = (type) => {
        switch (type) {
            case 'pan':
                setPanDocument(null);
                setPanPreview(null);
                setPanFileName('');
                break;
            case 'gst':
                setGstDocument(null);
                setGstPreview(null);
                setGstFileName('');
                break;
            case 'other':
                setOtherDocument(null);
                setOtherPreview(null);
                setOtherFileName('');
                break;
            default:
                break;
        }
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
        setSnackbarSeverity(snackbarSeverity);
        setResponseMessage('');
    };

    const columns = [
        {
            field: 'recipient_gstin',
            headerName: 'GSTIN',
            flex: 1,
            minWidth: 150,
            align: 'left',
            filterable: true,
        },
        {
            field: 'recipient_legal_name',
            headerName: 'Legal Name',
            flex: 1,
            minWidth: 200,
            align: 'left',
            filterable: true,
        },
        {
            field: 'master_type',
            headerName: 'Matser Type',
            flex: 1,
            minWidth: 200,
            align: 'left',
            filterable: true,
        },
        {
            field: 'recipient_trade_name',
            headerName: 'Trade Name',
            flex: 1,
            minWidth: 200,
            align: 'left',
            filterable: true,
        },
        {
            field: 'recipient_address_one',
            headerName: 'Primary Address',
            flex: 1,
            minWidth: 200,
            align: 'left',
            filterable: true,
        },
        {
            field: 'recipient_address_two',
            headerName: 'Secondary Address',
            flex: 1,
            minWidth: 200,
            align: 'left',
            filterable: true,
        },
        {
            field: 'recipient_location',
            headerName: 'Location',
            flex: 0.7,
            minWidth: 120,
            pinned: 'left',
            align: 'left',
            filterable: true,
        },
        {
            field: 'recipient_pincode',
            headerName: 'Pincode',
            flex: 0.7,
            minWidth: 120,
            pinned: 'left',
            align: 'left',
            filterable: true,
        },
        {
            field: 'recipient_email',
            headerName: 'Email',
            flex: 1,
            minWidth: 180,
            align: 'left',
            filterable: true,
        },
        {
            field: 'recipient_phone',
            headerName: 'Phone',
            flex: 1,
            minWidth: 180,
            align: 'left',
            filterable: true,
        },
        {
            field: 'actions',
            headerName: 'Action',
            flex: 1,
            minWidth: 200,
            align: 'left',
            renderCell: (params) => {
                const row = params.row;
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
                        <IconButton
                            size="medium"
                            onClick={() => handleOpenSupplierFormDialog('view', row.id)}
                            title="View Master"
                        >
                            <VisibilityIcon fontSize="medium" style={{ color: '#455a64' }} />
                        </IconButton>
                        <IconButton
                            size="medium"
                            onClick={() => handleOpenSupplierFormDialog('edit', row.id)}
                            title={row.editable ? 'Edit Company' : 'Tax Invoice Generated, Cannot Edit'}
                            disabled={!row.editable}
                            style={{ pointerEvents: row.editable ? 'auto' : 'auto' }}
                        >
                            <EditIcon fontSize="medium" style={{ color: row.editable ? '#455a64' : '#B0BEC5' }} />
                        </IconButton>
                        <IconButton
                            size="medium"
                            onClick={() => handleOpenAddressDialog(row)}
                            title="Add Address"
                        >
                            <AddLocationIcon fontSize="medium" style={{ color: '#455a64' }} />
                        </IconButton>
                    </div>
                );
            },
            filterable: false,
        },
    ];

    useEffect(() => {
        getCompanyData();
        getGstinInfo();

        console.log('form data..................', formData);
    }, []);

    // useEffect(() => {
    //     if (formData.pinCode && formData.pinCode.length === 6 && supplierDailogKey === 'add' && (!['Export', 'Import'].includes(formData.gstinReg))) {
    //         getAddressByPincode(formData.pinCode);
    //     }
    // }, [formData.pinCode]);

    // useEffect(() => {
    //     if (addressForm.pinCode && addressForm.pinCode.length === 6) {
    //         getAddressByPincodeForAddressDailog();
    //     }
    // }, [addressForm.pinCode]);

    useEffect(() => {
        const common = [
            { value: 'Regular', label: 'Regular' },
            { value: 'Un-Registered', label: 'Un-Registered' },
            { value: 'Composition', label: 'Composition' },
            { value: 'SEZ', label: 'SEZ' },
        ];
        let specific = [];
        if (formData.mastertype === 'CUSTOMER') {
            specific = [
                { value: 'Export', label: 'Export' },
                { value: 'Deemed Export', label: 'Deemed Export' },
            ];
        } else if (formData.mastertype === 'VENDOR') {
            specific = [
                { value: 'Import', label: 'Import' },
                { value: 'Deemed Import', label: 'Deemed Import' },
            ];
        }
        setGstinRegList([...common, ...specific]);
    }, [formData.mastertype]);

    useEffect(() => {
        if (!gstinRegList.some(item => item.value === formData.gstinReg)) {
            setFormData(prev => ({ ...prev, gstinReg: 'Regular' }));
        }
    }, [gstinRegList]);

    const getCompanyData = () => {
        setForm16DataLoading(true);
        axios
            .get(`/einvoice/get_recipient_master_details/${localStorage.getItem('business_entity_id')}/${localStorage.getItem('gst')}`)
            .then((res) => {
                if (res?.data?.status) {
                    const records = res?.data?.records;
                    setSupplierData(records);
                }
            })
            .catch((err) => { })
            .finally(() => {
                setForm16DataLoading(false);
            });
    };


    const extractPANFromGSTIN = (gstin) => {
        if (!gstin || gstin.length < 10) return '';
        // PAN is characters 3-12 (index 2-11) of GSTIN
        return gstin.substring(2, 12).toUpperCase();
    };

    const validatePANMatchesGSTIN = (gstin, pan) => {
        if (!gstin || !pan) return true; 
        if (['Un-Registered', 'Export', 'Import'].includes(formData.gstinReg)) return true; // Skip validation for special cases

        const extractedPAN = extractPANFromGSTIN(gstin);
        return extractedPAN === pan.toUpperCase();
    };

    const getGstinInfo = () => {
        console.log("supplierDailogKey...................", supplierDailogKey)
        axios
            .get(`/einvoice/get_gst_info/${localStorage.getItem('business_entity_id')}`)
            .then((res) => {
                if (res?.data?.status) {
                    const gstList = res?.data?.records || [];
                    // Include business_entity_id in gstArray for mapping
                    setGstArray(
                        gstList.map((item) => ({
                            value: item.gstin,
                            label: item.entity_name,
                            business_entity_id: item.business_entity_id,
                        }))
                    );
                    if (gstList.length === 1 && supplierDailogKey === 'add') {
                        setFormData((prev) => ({
                            ...prev,
                            gstin: gstList[0].gstin,
                            // Set legalName later in getLegalNameInfo
                        }));
                    }
                }
            })
            .catch((err) => {
                console.error('Error fetching GSTIN info:', err);
            });
    };



    const getAddressByPincode = (pinCode, isView = false) => {
        setPincodeLoading(true);
        setPincodeValid(false);
        axios
            .get(`/einvoice/get_address_info/${pinCode}`)
            .then((res) => {
                if (res?.data?.status) {
                    const { area, district, state, location } = res?.data?.address_info;
                    if (!isView) {
                        setFormData((prev) => ({
                            ...prev,
                            supplierAddress1: area || '',
                            supplierAddress2: location || '',
                            supplierLocation: district || '',
                            state: state || '',
                        }));
                    }
                    setPincodeError('');
                    setStateArray(res?.data?.state_data || []);
                    setPincodeValid(true);
                }
            })
            .catch((err) => {

            })
            .finally(() => {
                setPincodeLoading(false);
            });
    };

    const getAddressByPincodeForAddressDailog = (pincode) => {
        setPincodeLoading(true);
        setPincodeValid(false);
        axios
            .get(`/einvoice/get_address_info/${pincode}`)
            .then((res) => {
                if (res?.data?.status) {
                    const { area, district, state, location } = res?.data?.address_info;
                    // const hasData = selectedSubAddress && Object.keys(selectedSubAddress).length > 0;
                    // if (!hasData) {
                    setAddressForm((prev) => ({
                        ...prev,
                        address1: area || '',
                        address2: location || '',
                        location: district || '',
                        state: state || '',
                    }));
                    // }
                    setPincodeError('');
                    setStateArray(res?.data?.state_data || []);
                    setPincodeValid(true);
                }
            })
            .catch((err) => { })
            .finally(() => {
                setPincodeLoading(false);
            });
    };

    const getSupplierInfo = (recipient_id) => {
        axios
            .get(`/einvoice/get_recipient_master_info/${recipient_id}`)
            .then((res) => {
                if (res?.data?.status) {
                    const data = res?.data?.record;

                    setFormData({
                        recipient_gstin: data.recipient_gstin || '',
                        recipient_pan: data.recipient_pan || '',
                        gstin: data.gstin || '',
                        tradeName: data.recipient_trade_name || '',
                        legalName: data.recipient_legal_name || '',
                        supplierAddress1: data.recipient_address_one || '',
                        supplierAddress2: data.recipient_address_two || '',
                        supplierLocation: data.recipient_location || '',
                        pinCode: data.recipient_pincode || '',
                        emailId: data.recipient_email || '',
                        phone: data.recipient_phone || '',
                        state: data.recipient_state || '',
                        mastertype: data.master_type || 'CUSTOMER',
                        common_recipient_id: data.common_recipient_id || null,
                        gstinReg: data.gstin_reg,
                    });

                    setPanDocument(data.recipient_pan_attachment || null);
                    setGstDocument(data.recipient_gst_attachment || null);
                    setOtherDocument(data.recipient_other_attachment || null);

                    setPanPreview(data.recipient_pan_attachment || null);
                    setGstPreview(data.recipient_gst_attachment || null);
                    setOtherPreview(data.recipient_other_attachment || null);

                    setPanFileName(data.pan_file_name || 'PAN Document');
                    setGstFileName(data.gst_file_name || 'GST Document');
                    setOtherFileName(data.other_file_name || 'Other Document');

                    getAddressByPincode(data.recipient_pincode, true);
                    setPreviewUrl(data.supplier_company_logo || null);
                }
            })
            .catch((err) => {
                console.error('Error fetching supplier info:', err);
            });
    };

    const getSupplierAddressDetails = (record) => {
        axios
            .get(`/einvoice/get_recipient_child_info/${record.id}`)
            .then((res) => {
                if (res?.data?.status) {
                    setSupplierAddresses(res?.data?.records || []);
                }
            })
            .catch((err) => { });
    };



    const handleOpenSupplierFormDialog = (dailogKey, common_recipient_id = null) => {
        if (common_recipient_id) {
            getSupplierInfo(common_recipient_id);
        } else {
            setFormData((prev) => ({
                ...prev,
                tradeName: '',
                legalName: '',
                supplierAddress1: '',
                supplierAddress2: '',
                supplierLocation: '',
                pinCode: '',
                emailId: '',
                phone: '',
                state: '',
                mastertype: 'CUSTOMER',
                gstinReg: 'Regular',
            }));
        }
        setSupplierDailogKey(dailogKey);
        setSupplierFormDialogOpen(true);
    };

    const clearSupplierForm = () => {
        setFormData({
            gstin: formData.gstin,
            recipient_gstin: '',
            recipient_pan: '',
            tradeName: '',
            legalName: '',
            supplierAddress1: '',
            supplierAddress2: '',
            supplierLocation: '',
            pinCode: '',
            emailId: '',
            phone: '',
            state: '',
            mastertype: 'CUSTOMER',
            gstinReg: 'Regular',
        });
        setLogoFile(null);
        setPreviewUrl(null);
        setError('');
        setStateArray([]);
        setPincodeError('');
        setPanError('');
        setPincodeValid(false);
        setPincodeLoading(false);
        setPanDocument(null);
        setGstDocument(null);
        setOtherDocument(null);
        setPanPreview(null);
        setGstPreview(null);
        setOtherPreview(null);
        setPanFileName('');
        setGstFileName('');
        setOtherFileName('');
    };

    const clearAddressForm = () => {
        setAddressForm({
            gstin: localStorage.getItem('gst'),
            pinCode: '',
            location: '',
            address1: '',
            address2: '',
            state: '',
        });
        setStateArray([]);
        setPincodeError('');
        setPincodeValid(false);
        setPincodeLoading(false);
        setSelectedSubAddress({});
    };

    const handleCloseSupplierFormDialog = () => {
        clearSupplierForm();
        setSubmitButtonLoading(false);
        setSupplierFormDialogOpen(false);
        setSelectedCompany({});
    };

    const handleOpenAddressDialog = (record) => {
        setSelectedCompany(record);
        getSupplierAddressDetails(record);
        setAddressDialogOpen(true);
    };

    const handleCloseAddressDialog = () => {
        clearAddressForm();
        setSubmitButtonLoading(false);
        setAddressDialogOpen(false);
        setSelectedCompany({});
    };


    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };


    const handleExportExcel = () => {
        const bid = localStorage.getItem('business_entity_id');
        const fileName = 'E-invoice Master';

        if (bid) {
            const url = `/einvoice/download_master_data/${bid}`;

            axios.get(url)
                .then(response => {

                    // Assuming the response data is a Base64 encoded string
                    const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                    const base64Data = response.data.file; // Adjust based on the actual response format
                    downloadBase64File(contentType, base64Data, `${fileName}.xlsx`);
                })
                .catch(error => {
                    console.error("Error exporting file:", error);
                });
        } else {
            console.error('Business entity ID not found in localStorage');
        }
    };


    const CustomToolbar = () => (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                height: '60px',
                flexWrap: 'wrap',
                gap: 1,
                padding: '3px 10px',
                backgroundColor: '#ffffff',
                borderRadius: '4px',
                boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
            }}
        >
            <Box sx={{ display: 'flex', gap: 1 }}>
                <GridToolbarColumnsButton
                    sx={{
                        variant: 'outlined',
                        borderColor: '#1976d2',
                        color: '#1976d2',
                        borderRadius: '4px',
                        padding: '2px 4px',
                        '&:hover': {
                            borderColor: '#1565c0',
                            backgroundColor: '#e3f2fd',
                        },
                    }}
                />
                <GridToolbarFilterButton
                    sx={{
                        variant: 'outlined',
                        borderColor: '#1976d2',
                        color: '#1976d2',
                        borderRadius: '4px',
                        padding: '2px 4px',
                        '&:hover': {
                            borderColor: '#1565c0',
                            backgroundColor: '#e3f2fd',
                        },
                    }}
                />
                <GridToolbarDensitySelector
                    sx={{
                        variant: 'outlined',
                        borderColor: '#1976d2',
                        color: '#1976d2',
                        borderRadius: '4px',
                        padding: '2px 4px',
                        '&:hover': {
                            borderColor: '#1565c0',
                            backgroundColor: '#e3f2fd',
                        },
                    }}
                />
            </Box>

            <Box sx={{ display: 'flex', gap: 1, alignSelf: 'center' }}>
                <Button
                    variant="outlined"
                    onClick={handleExportExcel}
                    size="small"
                    sx={{
                        color: '#26A69A',
                        borderRadius: '4px',
                        textTransform: 'none',
                        padding: '2px 10px',
                        borderColor: '#26A69A',
                        height: '40px'
                    }}
                >
                    <DownloadIcon sx={{ marginRight: '4px', fontSize: '18px' }} /> EXPORT
                </Button>
                <Button
                    variant="contained"
                    startIcon={<ControlPointIcon />}
                    onClick={() => handleOpenSupplierFormDialog('add')}
                    style={{ height: '40px', backgroundColor: '#00b0ff' }}
                >
                    Add Master
                </Button>
            </Box>
        </Box>
    );

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'gstinReg') {
            let updatedGstin = '';
            let updatedPinCode = '';
            let updatedSupplierAddress1 = ''
            let updatedSupplierAddress2 = ''
            let updatedSupplierLocation = ''
            let updatedState = ''

            if (['Un-Registered', 'Export', 'Import'].includes(value)) {
                // updatedGstin = 'URP' // value === 'Un-Registered' ? 'URP' : value;
                updatedGstin = value === 'Un-Registered' ? 'NA' : 'URP';

                if (value !== 'Un-Registered') {
                    updatedPinCode = '999999';
                    updatedSupplierAddress1 = ''
                    updatedSupplierAddress2 = ''
                    updatedSupplierLocation = ''
                    updatedState = 'Other Country'
                }
            }

            setPincodeValid(false);
            setPanError('');
            setFormData((prev) => ({
                ...prev,
                gstinReg: value,
                recipient_gstin: updatedGstin,
                pinCode: updatedPinCode,
                supplierAddress1: updatedSupplierAddress1,
                supplierAddress2: updatedSupplierAddress2,
                supplierLocation: updatedSupplierLocation,
                state: updatedState
            }));

        }

        else if (name === 'recipient_gstin') {
            const extractedPAN = extractPANFromGSTIN(value);

            setFormData((prev) => ({
                ...prev,
                recipient_gstin: value,
                // Only auto-fill PAN if GSTIN is valid format and not special cases
                recipient_pan: (!['Un-Registered', 'Export', 'Import'].includes(formData.gstinReg) &&
                    value.length >= 10)
                    ? extractedPAN
                    : prev.recipient_pan
            }));
            if (formData.recipient_pan && value.length >= 10) {
                if (!validatePANMatchesGSTIN(value, formData.recipient_pan)) {
                    setPanError('PAN does not match GSTIN');
                } else {
                    setPanError('');
                }
            }
        }
        // ✅ NEW CODE: Validate PAN when manually edited
        else if (name === 'recipient_pan') {
            setFormData((prev) => ({
                ...prev,
                [name]: value.toUpperCase()
            }));

            // Validate PAN matches GSTIN
            if (value && formData.recipient_gstin) {
                if (!validatePANMatchesGSTIN(formData.recipient_gstin, value)) {
                    setPanError('PAN does not match GSTIN');
                } else {
                    setPanError('');
                }
            } else {
                setPanError('');
            }
        }

        else {
            setFormData((prev) => ({
                ...prev,
                [name]: value
            }));
        }


        if (name === "pinCode") {
            if (value.length === 6) {
                setPincodeValid(true);
                getAddressByPincode(value);
            } else {
                setPincodeValid(false);
                setFormData(prev => ({
                    ...prev,
                    supplierAddress1: '',
                    supplierAddress2: '',
                    supplierLocation: '',
                    state: ''
                }));
            }
        };
    };


    const handleChangeAddressInfo = (e) => {
        const { name, value } = e.target;
        setAddressForm({ ...addressForm, [name]: value });
        if (name === "pinCode") {
            if (value.length === 6) {
                getAddressByPincodeForAddressDailog(value)
            } else {
                setPincodeValid(false);
                setFormData(prev => ({
                    ...prev,
                    address1: '',
                    address2: '',
                    location: '',
                    state: ''
                }));
            }
        }
    }

    const updateSupplierMaster = (payLoadData) => {
        axios
            .put('/einvoice/update_recipient_master', payLoadData)
            .then((res) => {
                if (res?.data?.status) {
                    handleSnackbarOpen(res.data.message, 'success');
                    handleCloseSupplierFormDialog();
                } else {
                    if (res?.data?.message) {
                        handleSnackbarOpen(res.data.message, 'error');
                    }
                }
            })
            .catch((err) => { })
            .finally(() => {
                setSubmitButtonLoading(false);
                getCompanyData();
            });
    };

    const createSupplierMaster = (payLoadData) => {
        axios
            .post('/einvoice/create_recipient_master', payLoadData)
            .then((res) => {
                if (res?.data?.status) {
                    handleSnackbarOpen(res.data.message, 'success');
                    handleCloseSupplierFormDialog();
                } else {
                    if (res?.data?.message) {
                        handleSnackbarOpen(res.data.message, 'error');
                    }
                }
            })
            .catch((err) => { })
            .finally(() => {
                setSubmitButtonLoading(false);
                getCompanyData();
            });
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (['Regular', 'Composition', 'SEZ'].includes(formData.gstinReg) && !formData.gstin) {
            setError('GSTIN is required for Regular, Composition, or SEZ types');
            return;
        }
        // if (!formData.legalName) {
        //     setError('Legal Name is required');
        //     return;
        // }

        setSubmitButtonLoading(true);
        const payLoadData = {
            ...formData,
            business_entity_id: localStorage.getItem('business_entity_id'),
            panAttachment: panDocument,
            gstAttachment: gstDocument,
            otherAttachment: otherDocument,
            entity_gstin: localStorage.getItem('gst'),
            branch_name: localStorage.getItem('branch_name')

        };

        switch (supplierDailogKey) {
            case 'edit':
                updateSupplierMaster(payLoadData);
                break;
            default:
                createSupplierMaster(payLoadData);
                break;
        }
    };

    const createSupplierSubAddress = (payLoadData) => {
        axios
            .post('/einvoice/create_recipient_child', payLoadData)
            .then((res) => {
                if (res?.data?.status) {
                    handleSnackbarOpen(res.data.message, 'success');
                    clearAddressForm();
                    getSupplierAddressDetails(selectedCompany);
                }
            })
            .catch((err) => { })
            .finally(() => {
                setSubmitButtonLoading(false);
            });
    };

    const updateSupplierSubAddress = (payLoadData) => {
        axios
            .put('/einvoice/update_recipient_child', payLoadData)
            .then((res) => {
                if (res?.data?.status) {
                    handleSnackbarOpen(res.data.message, 'success');
                    clearAddressForm();
                    getSupplierAddressDetails(selectedCompany);
                }
            })
            .catch((err) => { })
            .finally(() => {
                setSubmitButtonLoading(false);
            });
    };

    const handleSubmitAddressDailog = (event) => {
        event.preventDefault();
        setSubmitButtonLoading(true);
        const payLoadData = {
            ...addressForm,
            business_entity_id: localStorage.getItem('business_entity_id'),
            common_recipient_id: selectedCompany.common_recipient_id,
            common_recipient_child_id: selectedSubAddress.common_recipient_child_id,
            org_gstin: localStorage.getItem('gst'),
        };
        const hasData = selectedSubAddress && Object.keys(selectedSubAddress).length > 0;
        if (hasData) {
            updateSupplierSubAddress(payLoadData);
        } else {
            createSupplierSubAddress(payLoadData);
        }
    };

    const handleSubAddressEdit = (record) => {
        setAddressForm({
            legalName: record.legal_name,
            pinCode: record.pincode,
            location: record.location,
            address1: record.address_one,
            address2: record.address_two,
            state: record.state,
        });
        setSelectedSubAddress(record);
    };

    const AddCompanyDialog = () => {
        const isViewMode = supplierDailogKey === 'view';
        const isEditMode = supplierDailogKey === 'edit';
        const isNonEditableGstin = ['Un-Registered', 'Export', 'Deemed Export', 'Import'].includes(formData.gstinReg);

        return (
            <div sx={{ width: '100%', bgcolor: 'background.paper', borderRadius: 1, boxShadow: 1 }}>
                <Container maxWidth="lg" sx={{ py: 4 }}>
                    <ValidatorForm useRef="form" onSubmit={handleSubmit} onError={(errors) => console.log(errors)}>
                        {/* Basic Info */}
                        <Box sx={{ mb: 2 }}>
                            {/* <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Basic Information
                            </Typography> */}
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={3} mt={1}>
                                    <label style={{ display: 'block', marginBottom: '3px' }}>
                                        ENTITY NAME
                                        <span style={{ color: 'red' }}>*</span>:
                                    </label>

                                    <SelectInput
                                        choice_id="value"
                                        // requiredField="*"
                                        validator={['required']}
                                        errorMsg={['Entity Name is required']}
                                        choice_name="label"
                                        // SelectLabel="GSTIN"
                                        name="gstin"
                                        value={formData.gstin}
                                        textOnchangeFunction={handleChange}
                                        choices={gstArray}
                                        disabled={isViewMode || isEditMode}
                                        sx={{
                                            height: '40px', // Ensure consistent height
                                            '& .MuiSelect-select': {
                                                padding: '10px 14px', // Consistent padding
                                                fontSize: '1rem',
                                            },
                                        }}
                                    />

                                </Grid>
                                <Grid item xs={12} sm={3} mt={1}>
                                    <SelectInput
                                        choice_id="value"
                                        requiredField="*"
                                        validator={['required']}
                                        errorMsg={['This field is required']}
                                        choice_name="value"
                                        SelectLabel="Master Type"
                                        name="mastertype"
                                        value={formData.mastertype}
                                        textOnchangeFunction={handleChange}
                                        choices={masterList}
                                        disabled={isViewMode}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} mt={1}>
                                    <SelectInput
                                        choice_id="value"
                                        requiredField="*"
                                        validator={['required']}
                                        errorMsg={['This field is required']}
                                        choice_name="label"
                                        SelectLabel="GSTIN Type"
                                        name="gstinReg"
                                        value={formData.gstinReg}
                                        textOnchangeFunction={handleChange}
                                        choices={gstinRegList}
                                        disabled={isViewMode}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3}>
                                    <label>Recipient GSTIN</label>
                                    <span style={{ color: 'red' }}>*</span>:
                                    <TextValidator
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        name="recipient_gstin"
                                        value={formData.recipient_gstin}
                                        onChange={handleChange}
                                        validators={[
                                            'required',
                                            ...(!['Un-Registered', 'Export', 'Import'].includes(formData.gstinReg)
                                                ? ['matchRegexp:^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}[A-Za-z][0-9A-Za-z]{1}$']
                                                : [])
                                        ]}
                                        inputProps={{
                                            maxLength: 100,
                                            readOnly:
                                                isViewMode ||
                                                //isEditMode ||
                                                ['Un-Registered', 'Export', 'Import'].includes(formData.gstinReg)
                                        }}
                                        errorMessages={[
                                            'Recipient GSTIN is required',
                                            'Invalid GSTIN format'
                                        ]}
                                    />
                                </Grid>


                            </Grid>
                        </Box>

                        {/* Company Info */}
                        <Box sx={{ mb: 2 }}>
                            {/* <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Company Information
                            </Typography> */}
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={3} >
                                    <label>Recipient PAN:</label>
                                    <TextValidator
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        name="recipient_pan"
                                        value={formData.recipient_pan}
                                        onChange={handleChange}
                                        validators={[
                                            // 'required',
                                            "matchRegexp:^[A-Z]{5}[0-9]{4}[A-Z]{1}$",
                                        ]}
                                        inputProps={{
                                            maxLength: 10,
                                            readOnly:
                                                isViewMode
                                            // isEditMode 
                                            // ['Un-Registered', 'Export'].includes(formData.gstinReg)
                                        }}
                                        errorMessages={[
                                            'Invalid PAN format'
                                        ]}
                                        error={!!panError}
                                        helperText={panError || ''}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3}>
                                    <label>Trade Name</label>
                                    <span style={{ color: 'red' }}>*</span>:
                                    <TextValidator
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        name="tradeName"
                                        value={formData.tradeName}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 100, readOnly: isViewMode }}
                                        // errorMessages={['Trade Name is required']}
                                        validators={['required']}
                                        errorMessages={['This field is required']}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3}>

                                    <label>Legal Name</label>
                                    <span style={{ color: 'red' }}>*</span>:
                                    <TextValidator
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        name="legalName"
                                        value={formData.legalName}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 100, readOnly: isViewMode }}
                                        //errorMessages={['Trade Name is required']}
                                        validators={['required']}
                                        errorMessages={['This field is required']}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <label>Phone Number</label>
                                    <TextValidator
                                        InputProps={{ readOnly: isViewMode }}
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        name="phone"
                                        value={formData.phone ?? ''}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 10, readOnly: isViewMode }}
                                        onKeyPress={(event) => {
                                            if (!/^[0-9]$/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }}
                                    // validators={['required', 'matchRegexp:^\\d{10}$']}
                                    // errorMessages={['Phone number is required', 'Phone number must be exactly 10 digits']}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <label>Email Id</label>
                                    <TextValidator
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        name="emailId"
                                        value={formData.emailId}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 100, readOnly: isViewMode }}
                                        validators={['matchRegexp:^\\s*([a-zA-Z0-9._%+-]+)@[a-zA-Z0-9.-]+\\.(com|co\\.in|in|net|org|gamil\\.com|sh)\\s*$']}
                                        errorMessages={['Email is not valid']}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <label>
                                        Pincode
                                        <span style={{ color: 'red' }}>*</span>:
                                    </label>
                                    <TextValidator
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        name="pinCode"
                                        value={formData.pinCode}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 6, readOnly: isViewMode }}
                                        onKeyPress={(event) => {
                                            if (!/^[0-9]$/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }}
                                        validators={['required', 'matchRegexp:^[0-9]{6}$']}
                                        errorMessages={['This field is required', 'Must be a 6-digit pincode']}
                                        error={!!pincodeError}
                                        disabled={['Export', 'Import'].includes(formData.gstinReg)}
                                        helperText={pincodeError}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    {pincodeLoading ? (
                                                        <CircularProgress size={20} />
                                                    ) : pincodeValid ? (
                                                        <CheckCircleIcon style={{ color: 'green' }} />
                                                    ) : null}
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <label>
                                        Master Address
                                        <span style={{ color: 'red' }}>*</span>:
                                    </label>
                                    <TextValidator
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        name="supplierAddress1"
                                        value={formData.supplierAddress1}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 100, readOnly: isViewMode }}
                                        validators={['required']}
                                        errorMessages={['This field is required']}
                                    />
                                </Grid>

                            </Grid>
                        </Box>

                        {/* Address Info */}
                        <Box sx={{ mb: 2 }}>
                            {/* <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Address Information
                            </Typography> */}
                            <Grid container spacing={2}>

                                <Grid item xs={12} sm={4}>
                                    <label>
                                        Master Location
                                        <span style={{ color: 'red' }}>*</span>:
                                    </label>
                                    <TextValidator
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        name="supplierLocation"
                                        value={formData.supplierLocation}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 100, readOnly: isViewMode }}
                                        validators={['required']}
                                        errorMessages={['This field is required']}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <label>Master Address 2</label>
                                    <TextValidator
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        name="supplierAddress2"
                                        value={formData.supplierAddress2}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 100, readOnly: isViewMode }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <label>
                                        State
                                        <span style={{ color: 'red' }}>*</span>:
                                    </label>
                                    <TextValidator
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        name="state"
                                        value={formData.state}
                                        onChange={handleChange}
                                        validators={["required"]}
                                        errorMessages={["This field is required"]}
                                        inputProps={{ maxLength: 100, readOnly: isViewMode }}
                                        disabled={['Export', 'Import'].includes(formData.gstinReg)}
                                    />
                                </Grid>
                            </Grid>
                        </Box>

                        {/* Document Uploads */}
                        <Box sx={{ mb: 2 }}>
                            {/* <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>
                                Document Uploads
                            </Typography> */}
                            {error && (
                                <Typography color="error" variant="caption" sx={{ mb: 2, display: 'block' }}>
                                    {error}
                                </Typography>
                            )}
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={4}>
                                    <Box
                                        sx={{
                                            border: '1px dashed #ccc',
                                            borderRadius: '8px',
                                            p: 3,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: '100%',
                                            textAlign: 'center',
                                            cursor: isViewMode ? 'default' : 'pointer',
                                        }}
                                        component="label"
                                    >
                                        <CloudUploadIcon sx={{ fontSize: 40, color: '#888', mb: 1 }} />
                                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                            PAN Attachment
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: '#888' }}>
                                            Upload PAN card (PDF, JPG, PNG)
                                        </Typography>
                                        <input
                                            type="file"
                                            accept=".pdf,.jpg,.jpeg,.png"
                                            hidden
                                            onChange={(e) => handleDocumentUpload(e, 'pan')}
                                            disabled={isViewMode}
                                        />
                                        {panDocument && (
                                            <Box sx={{ mt: 2, width: '100%' }}>
                                                <Typography variant="caption" noWrap sx={{ display: 'block' }}>
                                                    {panFileName || 'PAN Document'}
                                                </Typography>
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    startIcon={<DeleteOutlineIcon />}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleRemoveDocument('pan');
                                                    }}
                                                    disabled={isViewMode}
                                                    sx={{ mt: 1 }}
                                                >
                                                    Remove
                                                </Button>
                                            </Box>
                                        )}
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Box
                                        sx={{
                                            border: '1px dashed #ccc',
                                            borderRadius: '8px',
                                            p: 3,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: '100%',
                                            textAlign: 'center',
                                            cursor: isViewMode ? 'default' : 'pointer',
                                        }}
                                        component="label"
                                    >
                                        <CloudUploadIcon sx={{ fontSize: 40, color: '#888', mb: 1 }} />
                                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                            GST Attachment
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: '#888' }}>
                                            Upload GST certificate (PDF, JPG, PNG)
                                        </Typography>
                                        <input
                                            type="file"
                                            accept=".pdf,.jpg,.jpeg,.png"
                                            hidden
                                            onChange={(e) => handleDocumentUpload(e, 'gst')}
                                            disabled={isViewMode}
                                        />
                                        {gstDocument && (
                                            <Box sx={{ mt: 2, width: '100%' }}>
                                                <Typography variant="caption" noWrap sx={{ display: 'block' }}>
                                                    {gstFileName || 'GST Document'}
                                                </Typography>
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    startIcon={<DeleteOutlineIcon />}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleRemoveDocument('gst');
                                                    }}
                                                    disabled={isViewMode}
                                                    sx={{ mt: 1 }}
                                                >
                                                    Remove
                                                </Button>
                                            </Box>
                                        )}
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Box
                                        sx={{
                                            border: '1px dashed #ccc',
                                            borderRadius: '8px',
                                            p: 3,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: '100%',
                                            textAlign: 'center',
                                            cursor: isViewMode ? 'default' : 'pointer',
                                        }}
                                        component="label"
                                    >
                                        <CloudUploadIcon sx={{ fontSize: 40, color: '#888', mb: 1 }} />
                                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                            Other Attachment
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: '#888' }}>
                                            Upload other documents (PDF, JPG, PNG)
                                        </Typography>
                                        <input
                                            type="file"
                                            accept=".pdf,.jpg,.jpeg,.png"
                                            hidden
                                            onChange={(e) => handleDocumentUpload(e, 'other')}
                                            disabled={isViewMode}
                                        />
                                        {otherDocument && (
                                            <Box sx={{ mt: 2, width: '100%' }}>
                                                <Typography variant="caption" noWrap sx={{ display: 'block' }}>
                                                    {otherFileName || 'Other Document'}
                                                </Typography>
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    startIcon={<DeleteOutlineIcon />}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleRemoveDocument('other');
                                                    }}
                                                    disabled={isViewMode}
                                                    sx={{ mt: 1 }}
                                                >
                                                    Remove
                                                </Button>
                                            </Box>
                                        )}
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>

                        {/* Submit Buttons */}
                        {/* {!isViewMode && (
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
                                <Button variant="outlined" sx={{ mr: 2 }} onClick={clearSupplierForm}>
                                    Clear
                                </Button>
                                <LoadingButton
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    loading={submitButtonLoading}
                                >
                                    Submit
                                </LoadingButton>
                            </Box>
                        )} */}
                    </ValidatorForm>
                </Container>
            </div>
        );
    };

    const AddressDialogContent = () => {
        const isEditMode = supplierDailogKey === 'edit';
        const isViewMode = supplierDailogKey === 'add';
        return (
            <Container maxWidth="lg" sx={{ mt: 1, mb: 2 }}>
                <Paper sx={{ p: 2, borderRadius: 3, backgroundColor: 'background.paper' }}>
                    <Typography variant="h6" fontWeight={550} gutterBottom>
                        {isEditMode ? 'Edit Master Address' : 'Add Master Address'}
                    </Typography>
                    <ValidatorForm onSubmit={handleSubmitAddressDailog} onError={(errors) => console.log(errors)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={4}>
                                <label>
                                    GSTIN
                                    <span style={{ color: 'red' }}>*</span>:
                                </label>
                                <TextValidator
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="gstin"
                                    value={selectedCompany.recipient_gstin}
                                    onChange={handleChange}
                                    inputProps={{ maxLength: 100, readOnly: true }}
                                    errorMessages={['GSTIN is required']}
                                    requiredField="*"
                                    validator={['required']}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <label>
                                    Pincode
                                    <span style={{ color: 'red' }}>*</span>:
                                </label>
                                <TextValidator
                                    label="Pincode *"
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="pinCode"
                                    value={addressForm.pinCode}
                                    onChange={handleChangeAddressInfo}
                                    inputProps={{ maxLength: 6 }}
                                    onKeyPress={(e) => {
                                        if (!/^[0-9]$/.test(e.key)) e.preventDefault();
                                    }}
                                    validators={['required', 'matchRegexp:^[0-9]{6}$']}
                                    errorMessages={['This field is required', 'Must be a 6-digit pincode']}
                                    error={!!pincodeError}
                                    helperText={pincodeError}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                {pincodeLoading ? (
                                                    <CircularProgress size={20} />
                                                ) : pincodeValid ? (
                                                    <CheckCircleIcon sx={{ color: 'green' }} />
                                                ) : null}
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <label>
                                    Location
                                    <span style={{ color: 'red' }}>*</span>:
                                </label>
                                <TextValidator
                                    label="Location *"
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="location"
                                    value={addressForm.location}
                                    onChange={handleChangeAddressInfo}
                                    inputProps={{ maxLength: 100 }}
                                    validators={['required']}
                                    errorMessages={['This field is required']}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <label>
                                    Primary Address
                                    <span style={{ color: 'red' }}>*</span>:
                                </label>
                                <TextValidator
                                    label="Address Line 1 *"
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="address1"
                                    value={addressForm.address1}
                                    onChange={handleChangeAddressInfo}
                                    inputProps={{ maxLength: 100 }}
                                    validators={['required']}
                                    errorMessages={['This field is required']}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <label>
                                    Secondary Address
                                    <span style={{ color: 'red' }}>*</span>:
                                </label>
                                <TextValidator
                                    label="Address Line 2 *"
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="address2"
                                    value={addressForm.address2}
                                    onChange={handleChangeAddressInfo}
                                    inputProps={{ maxLength: 100 }}
                                    validators={['required']}
                                    errorMessages={['This field is required']}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>

                                <label>
                                    State
                                    <span style={{ color: 'red' }}>*</span>:
                                </label>
                                <TextValidator
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="state"
                                    value={addressForm.state}
                                    onChange={handleChangeAddressInfo}
                                    validators={["required"]}
                                    errorMessages={["This field is required"]}
                                    inputProps={{ maxLength: 100, readOnly: isViewMode }}
                                />
                            </Grid>
                        </Grid>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                            <Button
                                variant="outlined"
                                sx={{
                                    mr: 2,
                                    color: 'text.secondary',
                                    borderColor: 'text.secondary',
                                    '&:hover': {
                                        backgroundColor: 'action.hover',
                                        borderColor: 'text.primary',
                                    },
                                }}
                                onClick={clearAddressForm}
                            >
                                Clear
                            </Button>
                            <LoadingButton
                                variant="contained"
                                color="primary"
                                type="submit"
                                loading={submitButtonLoading}
                            >
                                Submit
                            </LoadingButton>
                        </Box>
                    </ValidatorForm>
                </Paper>
                <Paper
                    elevation={3}
                    sx={{
                        mt: 2,
                        p: 1,
                        borderRadius: 3,
                        backgroundColor: '#fafafa',
                        boxShadow: '0px 1px 10px rgba(0,0,0,0.05)',
                    }}
                >
                    <Typography
                        variant="h6"
                        fontWeight={550}
                        gutterBottom
                        style={{ marginLeft: 4 }}
                    >
                        Additional Address
                    </Typography>
                    <TableContainer
                        sx={{ boxShadow: 2, borderRadius: 2, overflow: 'hidden', bgcolor: 'background.paper' }}
                    >
                        <Table size="small">
                            <TableHead>
                                <TableRow
                                    sx={{
                                        bgcolor: 'primary.main',
                                        color: 'white',
                                        '& th': { fontWeight: 'bold', fontSize: '1rem' },
                                    }}
                                >
                                    <TableCell sx={{ color: '#000000' }}>Primary Address</TableCell>
                                    <TableCell sx={{ color: '#000000' }}>Secondary Address</TableCell>
                                    <TableCell sx={{ color: '#000000' }}>Location</TableCell>
                                    <TableCell sx={{ color: '#000000' }}>State</TableCell>
                                    <TableCell sx={{ color: '#000000' }}>Pincode</TableCell>
                                    <TableCell align="center" sx={{ color: '#000000' }}>
                                        Action
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {supplierAddresses.length === 0 ? (
                                    <TableRow>
                                        <TableCell
                                            colSpan={6}
                                            align="center"
                                            sx={{ padding: 2, color: 'red' }}
                                        >
                                            No Data Available
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    supplierAddresses.map((supplier) => (
                                        <TableRow
                                            key={supplier.id}
                                            hover
                                            sx={{
                                                '&:hover': { bgcolor: 'action.hover' },
                                                transition: 'all 0.2s ease',
                                            }}
                                        >
                                            <TableCell sx={{ padding: 2 }}>{supplier.address_one}</TableCell>
                                            <TableCell sx={{ padding: 2 }}>{supplier.address_two}</TableCell>
                                            <TableCell sx={{ padding: 2 }}>{supplier.location}</TableCell>
                                            <TableCell sx={{ padding: 2 }}>{supplier.state}</TableCell>
                                            <TableCell sx={{ padding: 2 }}>{supplier.pincode}</TableCell>
                                            <TableCell align="center" sx={{ padding: 2 }}>
                                                <IconButton
                                                    size="small"
                                                    sx={{
                                                        backgroundColor: 'action.selected',
                                                        color: 'text.primary',
                                                        '&:hover': {
                                                            backgroundColor: 'primary.main',
                                                            color: 'white',
                                                        },
                                                    }}
                                                    onClick={() => handleSubAddressEdit(supplier)}
                                                >
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Container>
        );
    };

    return (
        <div>
            <Box sx={{ height: '65vh', width: '100%', marginTop: '0.8%' }}>
                <DataGridPro
                    rows={supplierData}
                    columns={columns}
                    loading={form16DataLoading}
                    localeText={{
                        toolbarDensity: 'Size',
                        toolbarDensityLabel: 'Size',
                        toolbarDensityCompact: 'Small',
                        toolbarDensityStandard: 'Medium',
                        toolbarDensityComfortable: 'Large',
                    }}
                    sx={{
                        maxHeight: '65vh',
                        '& .MuiDataGrid-columnHeaders': {
                            color: '#fff',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            textAlign: 'right',
                            zIndex: 1000,
                        },
                        '& .MuiDataGrid-columnHeader': {
                            position: 'relative',
                            textAlign: 'right',
                            width: '100%',
                            fontWeight: 'bold',
                            backgroundColor: '#607d8b',
                        },
                        '& .MuiDataGrid-columnHeaderTitle': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-sortIcon': {
                            opacity: 'inherit !important',
                        },
                        '& .MuiDataGrid-iconButtonContainer': {
                            visibility: 'visible',
                        },
                        '& .MuiDataGrid-menuIconButton': {
                            opacity: '1 !important',
                            visibility: 'visible !important',
                            display: 'flex !important',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            '& .MuiDataGrid-columnHeader': {
                                '& .MuiDataGrid-menuIconButton': {
                                    display: 'flex !important',
                                    visibility: 'visible !important',
                                    opacity: '1 !important',
                                },
                            },
                        },
                        '& .MuiDataGrid-columnHeaderIcon': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                            backgroundColor: '#f9f9f9',
                        },
                        '& .MuiDataGrid-row:nth-of-type(even)': {
                            backgroundColor: '#ffffff',
                        },
                        '& .MuiDataGrid-cell': {
                            padding: '8px',
                            textAlign: 'center',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            backgroundColor: '#f0f0f0',
                        },
                        '& .MuiCheckbox-root': {
                            color: '#1976d2',
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: '#d3e3fc',
                            cursor: 'pointer',
                        },
                    }}
                    pagination
                    pageSize={5}
                    pageSizeOptions={[5, 10, 25, 50]}
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                />
            </Box>
            <Dialog
                open={supplierFormDialogOpen}
                onClose={handleCloseSupplierFormDialog}
                fullWidth
                maxWidth="lg"
                PaperProps={{
                    sx: {
                        borderRadius: 4,
                        boxShadow: 24,
                        px: 2,
                        py: 1,
                        marginLeft: 8,
                        bgcolor: 'background.default',
                    },
                }}
            >
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pb: 1,
                        borderBottom: 1,
                        borderColor: 'divider',
                    }}
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <BusinessIcon color="primary" />
                        <Typography variant="h6" fontWeight="bold">
                            {supplierDailogKey === 'add' && 'Add Master'}
                            {supplierDailogKey === 'edit' && 'Edit Master'}
                            {supplierDailogKey === 'view' && 'View Master'}
                        </Typography>
                    </Box>
                    <IconButton onClick={handleCloseSupplierFormDialog} size="small">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers sx={{ px: 3, py: 2 }}>
                    {AddCompanyDialog()}
                </DialogContent>
                <DialogActions
                    sx={{
                        justifyContent: 'flex-end',
                        px: 3,
                        py: 2,
                        borderTop: 1,
                        borderColor: 'divider',
                        bgcolor: 'background.default',
                    }}
                >
                    {supplierDailogKey !== 'view' && (
                        <>
                            <Button variant="outlined" sx={{ mr: 1 }} onClick={clearSupplierForm}>
                                Clear
                            </Button>
                            <LoadingButton
                                variant="contained"
                                color="primary"
                                onClick={(e) => {
                                    const form = document.querySelector('form');
                                    if (form) {
                                        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
                                    }
                                }}
                                loading={submitButtonLoading}
                            >
                                Submit
                            </LoadingButton>
                        </>
                    )}
                    <Button onClick={handleCloseSupplierFormDialog} variant="outlined">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={addressDialogOpen}
                onClose={handleCloseAddressDialog}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                    <Typography
                        variant="h6"
                        fontWeight={550}
                        gutterBottom
                        style={{ marginLeft: 4 }}
                    >
                        Manage Addresses
                    </Typography>
                    <IconButton onClick={handleCloseAddressDialog} size="small">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>{AddressDialogContent()}</DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseAddressDialog}>Close</Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={snackbarOpen}
                autoHideDuration={4500}
                onClose={handleSnackbarClose}
                style={{ maxWidth: '25%' }}
            >
                <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                >
                    {responseMessage}
                    {message}
                </MuiAlert>
            </Snackbar>
        </div>
    );
};

export default MasterTable;